import React from 'react';
import styled from 'styled-components';
import { pmWhite, pmBlack } from '../sharedData/Constants';
import {ReactComponent as ArrowDiagonal}  from '../assets/images/arrow_diagonal.svg';

const GoToSite = () => {
    return (
      <StyledButton target="_blank" href="https://www.pmweb.com.br">
        Acesse o nosso site
        <ArrowDiagonal/>
      </StyledButton>
    );
}

const StyledButton = styled.a`
   width: 162px;
   height: 42px;
   border: 1px solid rgba(255, 255, 255, 0.68);
   background-color: ${pmBlack};
   color: ${pmWhite};
   font-size: 12px;
   display: flex;
   align-items: center;
   border-radius: 10px;
   padding: 0 0 0 15px;
   cursor: pointer;
   text-decoration: none;
   @media screen and (max-width: 380px){
      margin-top: 15px;
    }
`;

export default GoToSite;